export const MENU_OFFSET_X_PROPORTION = 0.5;
export const MENU_OFFSET_Y_PROPORTION = 0.55;
